<template>
  <div class="min-h-dynamic bg-gray-50 overflow-y-auto">
    <div class="sm:max-w-5xl sm:mx-auto sm:pt-12 h-dynamic">
      <div
        class="bg-gradient sm:border border-gray-200 sm:shadow-sm sm:rounded-xl flex flex-col items-center justify-center h-dynamic sm:h-auto relative"
      >
        <div class="sm:rounded-xl pt-10 pb-20 self-stretch">
          <div
            v-if="showSelectSpaceButton"
            class="cursor-pointer bg-brand-600 rounded-md p-2 absolute top-3.5 right-3.5 hover:opacity-80"
            @click="handleChangeSpace"
            :title="t('components.messenger.problems.change')"
          >
            <SwitchHorizontal2 class="text-white w-5 h-5" />
          </div>

          <slot name="header" />
          <slot name="content" />
        </div>

        <div
          class="absolute bottom-0 w-full px-4 py-4 mt-2 flex items-center justify-between max-w-2xl"
        >
          <messenger-language
            :active="currentLocale"
            @language-selected="handleLanguageSelected"
            class="!text-white"
            inverted
          />

          <a href="https://fixform.com" target="_blank">
            <Logo inverted class="h-5 w-auto" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Logo from "@/Tailwind/Components/Logo.vue";
import { onMounted, ref } from "vue";
import SwitchHorizontal2 from "@/Tailwind/Icon/SwitchHorizontal2.vue";
import { router } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";
import { usePage } from "@inertiajs/vue3";
import { useCookies } from "vue3-cookies";
import { defineEmits } from "vue";
import MessengerLanguage from "@/Tailwind/Components/MessengerLanguage.vue";
import route from "ziggy-js";

defineProps({
  title: String,
  description: String,
  backLink: String,
  backLinkLabel: String,
  showSelectSpaceButton: {
    type: Boolean,
    default: false,
  },
});

const { cookies } = useCookies();

const i18n = useI18n();
const { t } = i18n;
const { messages } = useI18n();

const defaultLocale = usePage().props.locale;
const currentLocale = ref(cookies.get("messenger_locale") || defaultLocale);

const tenant = usePage().props.tenant;

function handleLanguageSelected(locale) {
  const html = document.documentElement;
  html.setAttribute("lang", locale);
  cookies.set("messenger_locale", locale);
  currentLocale.value = locale;

  i18n.locale.value = locale;

  emit("locale-changed", currentLocale.value);
}

const isValidLocale = (locale) => {
  return Object.keys(messages.value).includes(locale);
};

const getBrowserLocale = () => {
  const locale = navigator.language.substring(0, 2);

  if (isValidLocale(locale)) {
    return locale;
  }

  return defaultLocale;
};

const emit = defineEmits(["locale-changed"]);

onMounted(() => {
  const currentLocale = cookies.get("messenger_locale");
  if (currentLocale) {
    emit("locale-changed", currentLocale);
    return;
  }

  const locale = getBrowserLocale();
  const html = document.documentElement;
  html.setAttribute("lang", locale);
  cookies.set("messenger_locale", locale);

  i18n.locale.value = locale;

  emit("locale-changed", locale);
});

function handleChangeSpace() {
  router.get(route("space.select", [tenant.slug]));
}
</script>
